import {
    createProperties,
    type Field,
    Form,
    type FormState,
    type TypeToFields,
} from '@jmvdevelop/svelte-form';

export type AmenagementFoncierFormData = {
    projectType: string | null;
    geographicLocation: string | null;
    specificServices: readonly string[];
};
type FormData = AmenagementFoncierFormData;

export type Fields<TFormValues> = TypeToFields<TFormValues, AmenagementFoncierFormData>;

export const empty: FormData = {
    projectType: null,
    geographicLocation: null,
    specificServices: [],
};

export function createFields<TValues>(self: Field<TValues, FormData>) {
    return {
        self: self,
        ...createProperties(self, [
            'projectType',
            'geographicLocation',
            'specificServices',
        ] as const),
    };
}

export function validateAmenagementFoncier<TRootFormData>(
    _form: Form<TRootFormData, string>,
    _values: FormData,
    _fields: Fields<TRootFormData> | undefined | null,
) {
    return (state: FormState<TRootFormData, string>) => {
        return state;
    };
}
